var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNumberFour(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 63,
    height: 63,
    viewBox: "0 0 63 63",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 31.5,
    cy: 31.5,
    r: 31.5,
    fill: "#E61F2A"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.519 37.97V33.692L28.315 19.68H34.236V33.382H36.778V37.97H34.236V42H28.935V37.97H18.519ZM29.307 25.508L24.099 33.382H29.307V25.508ZM42.3815 42.248C41.4515 42.248 40.6868 41.9793 40.0875 41.442C39.5088 40.884 39.2195 40.202 39.2195 39.396C39.2195 38.5693 39.5088 37.877 40.0875 37.319C40.6868 36.761 41.4515 36.482 42.3815 36.482C43.2908 36.482 44.0348 36.761 44.6135 37.319C45.2128 37.877 45.5125 38.5693 45.5125 39.396C45.5125 40.202 45.2128 40.884 44.6135 41.442C44.0348 41.9793 43.2908 42.248 42.3815 42.248Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNumberFour);
export default __webpack_public_path__ + "static/media/number-four.43903721.svg";
export { ForwardRef as ReactComponent };